import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'quorum-vehicle-diagnostics',
  templateUrl: './vehicle-diagnostics.component.html',
  styleUrls: ['./vehicle-diagnostics.component.scss'],
})
export class VehicleDiagnosticsComponent implements OnInit {
  @Input() oem!: string;
  oemName!: string;
  constructor() {}

  ngOnInit(): void {
    this.oemName = this.getOemName(this.oem);
  }

  getOemName(oem: string) {
    switch (oem) {
      case 'GM':
        return 'GM';
      case 'FO':
        return 'Ford';
      case 'TOY':
        return 'Toyota';
      case 'CH':
        return 'Chrysler';
      case 'NIS':
        return 'Nissan';
      case 'HYU':
        return 'Hyundai';
      default:
        return 'OEM';
    }
  }
}
